// The Ask "commit" step -- save the reviewed proposal as an Event (plus an
// optional standing Condition), per `#foundation` "Ask flow" step 4 / `#s07`.
//
// Same conflict as `useAskPreview.ts` (execution plan §9 #9): no M1 endpoint,
// so this never issues a network call. `accept_ids` carries the ids the user
// KEPT (ticked rows), never an exclusion list -- the binding rule this
// workstream is strictest about. The server (once it exists) resolves labels
// to real ids; this hook never invents one.
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { AskUnavailableError } from './useAskPreview';

export const askCommitInputSchema = z.object({
  draft_id: z.string(),
  accept_ids: z.array(z.string()), // KEPT ids, never an exclusion list
  event_name: z.string(),
  tag_business: z.boolean(),
  save_condition: z.boolean(),
});
export type AskCommitInput = z.infer<typeof askCommitInputSchema>;

export const askCommitResultSchema = z.object({
  event_id: z.string(),
  batch_id: z.string(),
  count: z.number(),
});
export type AskCommitResult = z.infer<typeof askCommitResultSchema>;

export function useAskCommit() {
  return useMutation<AskCommitResult, AskUnavailableError, AskCommitInput>({
    mutationFn: async () => {
      // MOCKDATA: stands in for the Ask commit endpoint (no M1 endpoint
      // exists, see file header) -- resolves a plausible batch id/count so
      // the commit step can be clicked through end to end.
      throw new AskUnavailableError();
    },
  });
}
